module.exports = __webpack_public_path__ + "img/House2.b59b40c.jpg";